export function isAuthenticationError(error) {
  if (!error) return false;

  const AUTH_ERROR_MESSAGES = [
    "unauthorized",
    "token expired",
    "session expired",
    "access token has been revoked",
    "invalid token",
    "authentication failed",
  ];

  const AUTHORIZATION_ONLY_PHRASES = [
    "not authorized to access",
    "not authorized to perform",
    "forbidden",
    "permission denied",
  ];

  const firstGraphQLError = error?.errors?.[0];
  const message = (
    error?.message ||
    firstGraphQLError?.message ||
    error?.originalError?.message ||
    ""
  ).toLowerCase();
  const errorType =
    error?.name ||
    error?.errorType ||
    error?.code ||
    firstGraphQLError?.errorType ||
    error?.originalError?.name ||
    "";

  if (AUTHORIZATION_ONLY_PHRASES.some((phrase) => message.includes(phrase))) {
    return false;
  }

  if (errorType === "Unauthorized" || errorType === "NotAuthorizedException") {
    return true;
  }

  return AUTH_ERROR_MESSAGES.some((msg) => message.includes(msg));
}
